/**
 * Prompt 过滤管理 API
 */

import client from './client';

export interface FilterKeyword {
  id: number;
  keyword: string;
  language: string;
  category: string;
  is_active: number;
  created_at: string;
  updated_at: string;
  notes: string | null;
}

export interface FilterListResponse {
  success: boolean;
  data: {
    keywords: FilterKeyword[];
    pagination: {
      page: number;
      page_size: number;
      total: number;
    };
  };
}

/**
 * 获取过滤关键词列表
 */
export const listFilters = async (params?: {
  page?: number;
  page_size?: number;
  language?: string;
  category?: string;
  is_active?: boolean;
  search?: string;
}): Promise<FilterListResponse> => {
  const response = await client.get('/admin/filters', { params });
  return response.data;
};

/**
 * 创建过滤关键词
 */
export const createFilter = async (data: {
  keyword: string;
  language: string;
  category: string;
  is_active: boolean;
  notes?: string;
}): Promise<{ success: boolean; message: string; data: { id: number } }> => {
  const response = await client.post('/admin/filters', data);
  return response.data;
};

/**
 * 更新过滤关键词
 */
export const updateFilter = async (
  id: number,
  data: {
    keyword?: string;
    language?: string;
    category?: string;
    is_active?: boolean;
    notes?: string;
  }
): Promise<{ success: boolean; message: string }> => {
  const response = await client.put(`/admin/filters/${id}`, data);
  return response.data;
};

/**
 * 删除过滤关键词
 */
export const deleteFilter = async (id: number): Promise<{ success: boolean; message: string }> => {
  const response = await client.delete(`/admin/filters/${id}`);
  return response.data;
};

/**
 * 批量删除过滤关键词
 */
export const batchDeleteFilters = async (ids: number[]): Promise<{ 
  success: boolean; 
  message: string;
  data: { deleted_count: number };
}> => {
  const response = await client.post('/admin/filters/batch-delete', { ids });
  return response.data;
};
